import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AlertComponent } from '../components/message/alert/alert.component';
import { MaterialModule } from './material.module';
import { MessagePopupComponent } from '../components/message/message-popup/message-popup.component';
import { DetailsPopupComponent } from '../components/message/details-popup/details-popup.component';

@NgModule({
  declarations: [AlertComponent,
    MessagePopupComponent,
    DetailsPopupComponent],
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
    MaterialModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class MessageModule { }
